import { Link as RouterLink } from "react-router-dom";
import { PATH_CONTACT_CENTER, PATH_ONLINE } from "../../routes/paths";

export default function Login({ isContactCenter }) {
  return (
    <>
      <RouterLink
        to={
          isContactCenter
            ? PATH_CONTACT_CENTER.openingScript
            : PATH_ONLINE.accept
        }
        state={{ isAuth: true }}
      >
        Login
      </RouterLink>
    </>
  );
}
